var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19726 13.037L11.4371 9.7623C11.6132 9.58424 11.4885 9.27979 11.2393 9.27979H4.75973C4.5106 9.27979 4.38583 9.58424 4.56199 9.7623L7.8018 13.037C7.911 13.1474 8.08806 13.1474 8.19726 13.037Z",
    fill: "#92929E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19726 2.963L11.4371 6.2377C11.6132 6.41576 11.4885 6.72021 11.2393 6.72021L4.75973 6.72021C4.5106 6.72021 4.38583 6.41576 4.56199 6.2377L7.8018 2.963C7.911 2.85262 8.08806 2.85262 8.19726 2.963Z",
    fill: "#92929E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic_sort.6b28c01b2af4b2baba46dbf7ffb269f8.svg";
export { ForwardRef as ReactComponent };